import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";

export type IBFEndMarker = {};

export const IBF_END_MARKER = {
  value: 0x0000,
  name: "IBF_END_MARKER",
  size: 0,
  parse: (): IBFEndMarker => {
    return {};
  },
} satisfies IBFHistoryRecordDefinition<IBFEndMarker>;
